<section class="view-map">
  @if (imageStyle) {
    <div class="view-map__image-style">
      <div class="view-map__image-style__map">
        <button mb-button mb-button-small variant="principal" color="secondary" [disabled]="!(hotels$ | async)?.length"
          (click)="map(imageStyle)">
          <mb-icon icon="map"></mb-icon>
          <span i18n='@@hotel__see-in-map'>Ver alojamientos en mapa</span>
        </button>
      </div>
    </div>
  }

  @if (!imageStyle && !isMap && isMobile) {
    <button mb-button mb-button-small variant="floating"
      [disabled]="!(hotels$ | async)?.length" color="secondary" (click)="map(imageStyle)">
      <mb-icon icon="map"></mb-icon>
      <span>Mapa</span>
    </button>
  }

  @if (!imageStyle && isMap && isMobile) {
    <button mb-button mb-button-small variant="outline"
      [disabled]="!(hotels$ | async)?.length" color="secondary" (click)="map(imageStyle)">
      <mb-icon icon="hamburger"></mb-icon>
      <span>Lista</span>
    </button>
  }
</section>